/** @abacus 28106 - ha_pulse_activity_indicators */
import {compose} from 'redux';
import debounce from 'lodash.debounce';
import edap from '../edap';
import experiments from '../../abacus/experiments';
import {GET_INDICATORS, queryOptions} from './activity-indicator-graphql';
import {graphql} from 'react-apollo';
import React, {Component} from 'react';
import TestExposureOnce from '../../abacus/test-exposure-once';
import Tooltip from '@homeaway/react-tooltip';
import {withAuth} from '../../components/auth';
import {withTranslationsAsProps} from '../../components/translations';
import withAbacusTestValuesAsProps from '../../abacus/with-abacus-test-values-as-props/with-abacus-test-values-as-props';
import './activity-indicator.less';

/* istanbul ignore next */
const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
};

export const HA_PULSE_ACTIVITY_INDICATORS = experiments.HA_PULSE_ACTIVITY_INDICATORS;
export const testExposure = new TestExposureOnce(HA_PULSE_ACTIVITY_INDICATORS);

export const getClassIndex = (index = 0) => {
    let idx = index + 1;
    if (idx > 3) {
        if (idx % 5 === 0) {
            return 5;
        }
        if (idx % 3 === 0) {
            return 3;
        }
        if (idx % 2 === 0) {
            return 2;
        }
        return 1;
    }
    return idx;
};

export const hasNewActivity = (boardId, uuids = []) => {
    if (!Array.isArray(uuids)) {
        return false;
    }
    return uuids.indexOf(boardId) !== -1;
};

export function ActivityIndicatorIcon({boardId, langTooltip}) {
    // Tooltip fires the onOpen callback multiple times
    /* istanbul ignore next */
    const onOpen = debounce(() => {
        edap.activityIndicatorTooltip(boardId);
    }, 250);

    /** @edap */
    edap.activityIndicator(boardId);

    return (
        <Tooltip
            centered
            content={langTooltip}
            onOpen={onOpen}
            placement="top"
            tooltipType="tooltip"
            trigger="click hover"
            wrapperClassName="activity-indicator--tooltip"
        />
    );
}

export class ActivityIndicator extends Component {
    static defaultProps = {
        data: {},
        testValue: 0
    }

    static initialState = {
        index: -1,
        hasActivity: false
    }

    constructor(props) {
        super(props);
        this.state = this.getActivityState(props);
    }

    componentDidMount() {
        this.setActivityState(this.state);
    }

    shouldComponentUpdate({data: {loading}}, {hasActivity}) {
        const {data} = this.props;
        return (loading !== data.loading)
            || (hasActivity !== this.state.hasActivity);
    }

    componentDidUpdate() {
        const state = this.getActivityState(this.props);
        this.setActivityState(state);
    }

    getActivityState = (props = {}) => {
        const {boardId, data} = props;
        const {indicators} = data || [];
        const hasActivity = hasNewActivity(boardId, indicators);

        if (hasActivity) {
            return {
                hasActivity,
                index: indicators.indexOf(boardId)
            };
        }
        return ActivityIndicator.initialState;
    }

    setActivityState = (state = {}) => {
        const isAlreadyActive = this.state.hasActivity;
        if (!state.hasActivity || isAlreadyActive) {
            return;
        }

        /** @edap */
        testExposure.trigger(HA_PULSE_ACTIVITY_INDICATORS);

        /* istanbul ignore next */
        setTimeout(() => {
            this.setState(state);
        }, 0);
    }

    render() {
        const {hasActivity, index} = this.state;
        const {boardId, langTooltip, testValue} = this.props;

        if (testValue > 0) {
            if (hasActivity) {
                return (
                    <span
                        className={`activity-indicator activity-indicator--active activity-indicator--${getClassIndex(index)}`}
                        onClick={onClick}
                        onKeyPress={onClick}
                        role="none"
                    >
                        <ActivityIndicatorIcon
                            boardId={boardId}
                            langTooltip={langTooltip}
                        />
                    </span>
                );
            }

            return (
                <span
                    className="activity-indicator activity-indicator--none"
                    role="none"
                />
            );
        }

        return null;
    }
}

export default compose(
    withAuth,
    graphql(GET_INDICATORS, {options: queryOptions}),
    withAbacusTestValuesAsProps({
        [HA_PULSE_ACTIVITY_INDICATORS]: 'testValue'
    }),
    withTranslationsAsProps({
        'tripboards.new.activity': 'langTooltip'
    })
)(ActivityIndicator);


// WEBPACK FOOTER //
// ./src/universal/tripboard/activity-indicator/activity-indicator.js